const KEY = "healthos.onboarding.returnTo";

/** One leading `/`, so the value cannot name another origin. Same rule as the auth package's `readReturnTo`. */
function isAppPath(path: string): boolean {
  return path.startsWith("/") && !path.startsWith("//");
}

/**
 * Park the deep link a not-yet-onboarded member was heading to when the gate diverts them to /onboarding.
 *
 * A sign-up or sign-in link to `/challenges/123` lands a brand-new member on that path, and the gate immediately sends
 * them through the wizard; without this the wizard ends on Today and the challenge they came for is lost. Session
 * storage, not router state: the wizard leaves the app for connector OAuth and comes back on a fresh history entry.
 */
export function rememberOnboardingReturnTo(path: string): void {
  if (!isAppPath(path) || path === "/" || path.startsWith("/onboarding")) return;
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // storage unavailable; the member lands on Today instead
  }
}

/** The parked deep link, cleared as it is read, or null. */
export function takeOnboardingReturnTo(): string | null {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path && isAppPath(path) ? path : null;
  } catch {
    return null;
  }
}
